import { createIllustration, type SVGViewBox } from '@atlassian/jira-illustration';
import srcDark from '../../assets/branch-creation-options-with-issue-key-highlight.png'; // eslint-disable-line jira/import/no-parent-imports, import/no-duplicates, jira/import/no-duplicates
import srcLight from '../../assets/branch-creation-options-with-issue-key-highlight.png'; // eslint-disable-line jira/import/no-parent-imports, import/no-duplicates

const Illustration = createIllustration({
	srcLight,
	srcDark,
});

export default Illustration;

const viewBox: SVGViewBox = [0, 0, 328, 241];
export { srcLight, srcDark, viewBox };
